import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import PersistedStore from "./reducer/PersistedStore";
import { PopupContextProvider } from "./components/modal/Popup";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={PersistedStore.getDefaultStore().store}>
    <PopupContextProvider>
      <App></App>
    </PopupContextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
